import { SHARED_NAMESPACE } from './store/shared'

export const alertHandler = _ => {
  const ensureStore = ctx => {
    const store = ctx && ctx.$store
    if (!store) throw new Error('alertHandler methods must be called with a Vue component context (this.$store)')
    return store
  }

  const dispatchAlert = function (payload) {
    return ensureStore(this).dispatch(`${SHARED_NAMESPACE}/displayAlert`, payload)
  }

  const displayAlert = function (type, message, errorObject, options = {}) {
    const localAlert = {
      type,
      message,
      options,
    }

    if (type === 'error' && errorObject) localAlert.errorObject = errorObject

    return dispatchAlert.call(this, localAlert)
  }

  const displayError = function (message, errorObject, options = {}) { return displayAlert.call(this, 'error', message, errorObject, options) }
  const displaySuccess = function (message, options = {}) { return displayAlert.call(this, 'success', message, null, options) }
  const displayInfo = function (message, options = {}) { return displayAlert.call(this, 'info', message, null, options) }
  const displayWarning = function (message, options = {}) { return displayAlert.call(this, 'warning', message, null, options) }

  return {
    displayAlert,
    displayError,
    displaySuccess,
    displayInfo,
    displayWarning,
  }
}
